<template>
    <div class="suggest-product-card">
        <q-img
            basic
            :placeholder-src="require('@/assets/image-not-found.png')"
            height="60px"
            width="60px"
            contain
            :src="imageSrc"
            class="suggest-product-card-img"
            @error="retryImageSrc(info.cprcode, info.pr_use_original_img)"
        ></q-img>
        <div>
            <div class="text-primary text-bold">
                {{ info.hema_name_en }}
            </div>
            <div>
                {{ info.hema_brand_en }}
            </div>
        </div>
    </div>
</template>

<script>
import imageSrc from "@/mixins/imageSrc";
import { QItem, QItemSection, QRadio } from "quasar";
const components = {
    QItem,
    QItemSection,
    QRadio,
};
export default {
    name: "SuggestProductCard",
    components: {
        ...components,
    },
    props: ["info", "index"],
    mixins: [imageSrc],
    data() {
        return {
            selected: false,
        };
    },
    mounted() {
        this.initializeImageSrc(
            this.info.cprcode,
            this.info.pr_use_original_img
        );
    },
};
</script>

<style scoped>
.suggest-product-card {
    display: flex;
    flex: 1;
}
.suggest-product-card-img {
    min-width: 60px;
}
</style>
